<script lang="ts" setup>
import SearchForm from "@/components/SearchForm.vue"
</script>

<template>
  <div class="flex flex-col m-24 gap-8">
    <h1 class="sr-only">Zurückziehen</h1>
    <SearchForm></SearchForm>
  </div>
</template>
